import { render, staticRenderFns } from "./ApprovalOpinions.vue?vue&type=template&id=735e2105&"
import script from "./ApprovalOpinions.vue?vue&type=script&lang=js&"
export * from "./ApprovalOpinions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports